import type {
  EnhancedFieldConfig,
  EnhancedGroupedSection,
  EnhancedSection,
  FormSchemaConfig,
} from '../types';
import { isEnhancedGroupedSection } from '../types';

const stripField = (field: EnhancedFieldConfig): EnhancedFieldConfig => {
  const next: EnhancedFieldConfig = {
    ...field,
    required: false,
    validation: undefined,
  };

  // Table / nested schema fields may carry their own required flags.
  const tableSchema = (field as EnhancedFieldConfig & {
    formSchema?: FormSchemaConfig;
  }).formSchema;
  if (tableSchema?.sections) {
    (next as EnhancedFieldConfig & { formSchema?: FormSchemaConfig }).formSchema =
      stripSchemaValidationForTesting(tableSchema) ?? undefined;
  }

  return next;
};

const stripSection = (
  section: EnhancedSection | EnhancedGroupedSection
): EnhancedSection | EnhancedGroupedSection => {
  if (isEnhancedGroupedSection(section)) {
    return {
      ...section,
      sections: section.sections.map((subSection) =>
        stripSection(subSection)
      ) as EnhancedSection[],
    };
  }

  return {
    ...section,
    fields: section.fields?.map((field) => stripField(field)) ?? [],
  };
};

/**
 * Removes required flags and validators so FormStack will accept Submit
 * during local `permissions: true` testing (no backend).
 */
export const stripSchemaValidationForTesting = (
  schema: FormSchemaConfig | null | undefined
): FormSchemaConfig | null => {
  if (!schema?.sections) {
    return schema ?? null;
  }

  return {
    ...schema,
    sections: schema.sections.map((section) => stripSection(section)),
  };
};
